// src/components/league-creation/league-type/LeagueTypeSelector.js
import React from 'react';
import { Trophy, Calendar } from 'lucide-react';
import { dynastyTheme } from '../../../services/colorService';

const LeagueTypeSelector = ({ selectedType, onSelectType }) => {
  return (
    <div>
      <label className={`${dynastyTheme.components.label} ${dynastyTheme.classes.text.white} mb-3 block text-center`}>
        Choose Your League Type
      </label>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Dynasty Option */}
        <button
          type="button"
          onClick={() => onSelectType('dynasty')}
          className={`p-6 rounded-lg border-2 transition-all ${
            selectedType === 'dynasty'
              ? `border-yellow-500 ${dynastyTheme.classes.bg.primaryLight} shadow-lg shadow-yellow-500/30`
              : `border-gray-700 ${dynastyTheme.classes.bg.darkLighter} hover:border-gray-600 hover:shadow-lg`
          }`}
        >
          <div className="flex items-center justify-center mb-3">
            <Trophy className={`w-12 h-12 ${
              selectedType === 'dynasty'
                ? dynastyTheme.classes.text.primary
                : dynastyTheme.classes.text.neutralLight
            }`} />
          </div>
          <h3 className={`text-xl font-bold mb-2 ${
            selectedType === 'dynasty'
              ? dynastyTheme.classes.text.primary
              : dynastyTheme.classes.text.white
          }`}>
            Dynasty League
          </h3>
          <p className={`text-sm ${dynastyTheme.classes.text.neutralLight} leading-relaxed`}>
            Build a multi-year dynasty. Keep players year after year, manage contracts, 
            and develop long-term strategies. Perfect for dedicated managers who want deep team building.
          </p>
          
          {selectedType === 'dynasty' && (
            <div className="mt-4 pt-4 border-t border-yellow-500/30">
              <p className={`text-xs ${dynastyTheme.classes.text.primary} font-semibold`}>
                ✓ Selected
              </p>
            </div>
          )}
        </button>

        {/* Single Season (Redraft) Option */}
        <button
          type="button"
          onClick={() => onSelectType('redraft')}
          className={`p-6 rounded-lg border-2 transition-all ${
            selectedType === 'redraft'
              ? `border-yellow-500 ${dynastyTheme.classes.bg.primaryLight} shadow-lg shadow-yellow-500/30`
              : `border-gray-700 ${dynastyTheme.classes.bg.darkLighter} hover:border-gray-600 hover:shadow-lg`
          }`}
        >
          <div className="flex items-center justify-center mb-3">
            <Calendar className={`w-12 h-12 ${
              selectedType === 'redraft'
                ? dynastyTheme.classes.text.primary
                : dynastyTheme.classes.text.neutralLight
            }`} />
          </div>
          <h3 className={`text-xl font-bold mb-2 ${
            selectedType === 'redraft'
              ? dynastyTheme.classes.text.primary
              : dynastyTheme.classes.text.white
          }`}>
            Single Season
          </h3>
          <p className={`text-sm ${dynastyTheme.classes.text.neutralLight} leading-relaxed`}>
            Fresh start every year. All players return to the draft pool each season. 
            Perfect for casual leagues or managers who want a clean slate annually.
          </p>
          
          {selectedType === 'redraft' && (
            <div className="mt-4 pt-4 border-t border-yellow-500/30">
              <p className={`text-xs ${dynastyTheme.classes.text.primary} font-semibold`}>
                ✓ Selected
              </p>
            </div>
          )}
        </button>
      </div>
    </div>
  );
};

export default LeagueTypeSelector;